import type { Locale } from '../types';

export const COUNTRIES = [
  { code: 'US', rss: 'us', name: 'United States', zhName: '美国' },
  { code: 'CN', rss: 'cn', name: 'China mainland', zhName: '中国大陆' },
  { code: 'HK', rss: 'hk', name: 'Hong Kong', zhName: '中国香港' },
  { code: 'TW', rss: 'tw', name: 'Taiwan', zhName: '中国台湾' },
  { code: 'JP', rss: 'jp', name: 'Japan', zhName: '日本' },
  { code: 'KR', rss: 'kr', name: 'South Korea', zhName: '韩国' },
  { code: 'GB', rss: 'gb', name: 'United Kingdom', zhName: '英国' },
  { code: 'AU', rss: 'au', name: 'Australia', zhName: '澳大利亚' },
  { code: 'CA', rss: 'ca', name: 'Canada', zhName: '加拿大' },
  { code: 'DE', rss: 'de', name: 'Germany', zhName: '德国' },
  { code: 'FR', rss: 'fr', name: 'France', zhName: '法国' },
  { code: 'SG', rss: 'sg', name: 'Singapore', zhName: '新加坡' }
];

export const MEDIA_OPTIONS = [
  { value: 'all', label: 'All', zhLabel: '全部' },
  { value: 'music', label: 'Music', zhLabel: '音乐' },
  { value: 'movie', label: 'Movies', zhLabel: '电影' },
  { value: 'podcast', label: 'Podcasts', zhLabel: '播客' },
  { value: 'software', label: 'Apps', zhLabel: 'App' },
  { value: 'ebook', label: 'Books', zhLabel: '电子书' },
  { value: 'audiobook', label: 'Audio Books', zhLabel: '有声书' },
  { value: 'musicVideo', label: 'Music Videos', zhLabel: '音乐视频' },
  { value: 'tvShow', label: 'TV Shows', zhLabel: '电视节目' },
  { value: 'shortFilm', label: 'Short Films', zhLabel: '短片' }
];

export const ENTITY_OPTIONS: Record<string, Array<{ value: string; label: string; zhLabel: string }>> = {
  all: [
    { value: '', label: 'Best match', zhLabel: '最佳匹配' },
    { value: 'allTrack', label: 'All tracks', zhLabel: '所有曲目' },
    { value: 'allArtist', label: 'All artists', zhLabel: '所有艺人' }
  ],
  music: [
    { value: 'song', label: 'Songs', zhLabel: '歌曲' },
    { value: 'album', label: 'Albums', zhLabel: '专辑' },
    { value: 'musicArtist', label: 'Artists', zhLabel: '艺人' },
    { value: 'musicVideo', label: 'Music videos', zhLabel: '音乐视频' },
    { value: 'mix', label: 'Mixes', zhLabel: '混音' }
  ],
  movie: [
    { value: 'movie', label: 'Movies', zhLabel: '电影' },
    { value: 'movieArtist', label: 'Movie artists', zhLabel: '电影相关艺人' }
  ],
  podcast: [
    { value: 'podcast', label: 'Podcasts', zhLabel: '播客' },
    { value: 'podcastAuthor', label: 'Authors', zhLabel: '作者' }
  ],
  software: [
    { value: 'software', label: 'iPhone apps', zhLabel: 'iPhone App' },
    { value: 'iPadSoftware', label: 'iPad apps', zhLabel: 'iPad App' },
    { value: 'macSoftware', label: 'Mac apps', zhLabel: 'Mac App' }
  ],
  ebook: [
    { value: 'ebook', label: 'Books', zhLabel: '电子书' }
  ],
  audiobook: [
    { value: 'audiobook', label: 'Audio books', zhLabel: '有声书' },
    { value: 'audiobookAuthor', label: 'Authors', zhLabel: '作者' }
  ],
  musicVideo: [
    { value: 'musicVideo', label: 'Music videos', zhLabel: '音乐视频' }
  ],
  tvShow: [
    { value: 'tvEpisode', label: 'Episodes', zhLabel: '单集' },
    { value: 'tvSeason', label: 'Seasons', zhLabel: '季' }
  ],
  shortFilm: [
    { value: 'shortFilm', label: 'Short films', zhLabel: '短片' },
    { value: 'shortFilmArtist', label: 'Artists', zhLabel: '创作者' }
  ]
};

export const ATTRIBUTE_OPTIONS = [
  { value: '', label: 'Any field', zhLabel: '所有字段' },
  { value: 'allArtistTerm', label: 'Artist', zhLabel: '艺人' },
  { value: 'allTrackTerm', label: 'Title / track', zhLabel: '标题 / 曲目' },
  { value: 'albumTerm', label: 'Album', zhLabel: '专辑' },
  { value: 'songTerm', label: 'Song', zhLabel: '歌曲' },
  { value: 'movieTerm', label: 'Movie', zhLabel: '电影' },
  { value: 'titleTerm', label: 'Title', zhLabel: '标题' },
  { value: 'descriptionTerm', label: 'Description', zhLabel: '描述' },
  { value: 'softwareDeveloper', label: 'Developer', zhLabel: '开发者' },
  { value: 'genreIndex', label: 'Genre', zhLabel: '类型' }
];

export const RSS_PRESETS = [
  { id: 'music-songs', media: 'music', feed: 'most-played', type: 'songs', label: 'Top songs', zhLabel: '热门歌曲' },
  { id: 'music-albums', media: 'music', feed: 'most-played', type: 'albums', label: 'Top albums', zhLabel: '热门专辑' },
  { id: 'apps-free', media: 'apps', feed: 'top-free', type: 'apps', label: 'Top free apps', zhLabel: '免费 App 榜' },
  { id: 'apps-paid', media: 'apps', feed: 'top-paid', type: 'apps', label: 'Top paid apps', zhLabel: '付费 App 榜' },
  { id: 'podcasts-top', media: 'podcasts', feed: 'top', type: 'podcasts', label: 'Top podcasts', zhLabel: '热门播客' },
  { id: 'books-free', media: 'books', feed: 'top-free', type: 'books', label: 'Top free books', zhLabel: '免费图书榜' },
  { id: 'audiobooks-top', media: 'audio-books', feed: 'top', type: 'audio-books', label: 'Top audio books', zhLabel: '热门有声书' }
];

export const DISCOVER_LEGACY_RSS_RAILS = [
  { id: 'top-movies', feed: 'topmovies', label: 'Top movies', zhLabel: '热门电影' },
  { id: 'top-tv-episodes', feed: 'toptvepisodes', label: 'Top TV episodes', zhLabel: '热门 TV 单集' }
] as const;

export const NEWS_SOURCES = [
  { value: 'newsroom', label: 'Apple Newsroom', zhLabel: 'Apple 新闻室' },
  { value: 'developer-news', label: 'Developer News', zhLabel: '开发者新闻' },
  { value: 'developer-releases', label: 'Developer Releases', zhLabel: '开发者发布' }
];

export function countryName(code: string, locale: Locale) {
  const country = COUNTRIES.find((item) => item.code === code.toUpperCase());
  if (!country) return code.toUpperCase();
  return locale === 'zh' ? country.zhName : country.name;
}

export function countryFlag(code: string) {
  const normalized = code.toUpperCase();
  if (!/^[A-Z]{2}$/.test(normalized)) return '';
  return String.fromCodePoint(...[...normalized].map((char) => 127397 + char.charCodeAt(0)));
}

export function localizedOption<T extends { label: string; zhLabel: string }>(option: T, locale: Locale) {
  return locale === 'zh' ? option.zhLabel : option.label;
}
